import _e from 'common/localeUtil';
import {
	generateButtonClone,
	generateButtonDelete,
	generateButtonDrag,
} from './customComponentUtils';

const AchievementItemComponentFactory = (editor) => {
	editor.DomComponents.addType('achievement-item', {
		// Make the editor understand when to bind `my-input-type`
		isComponent: (el) => el && el.tagName === 'DIV' && el.classList?.contains('accolade'),
		// Model definition
		model: {
			// Default properties
			defaults: {
				tagName: 'div',
				attributes: {
					class: 'accolade column',
					configurable: true,
				},
				highlightable: true,
				draggable: 'div[class*="accolades-wrapper"]', // Can be dropped only inside `form` elements
				droppable: false, // Can't drop other elements inside
				removable: true,
				badgable: false,
				copyable: false,
				resizable: false,
				editable: true,
				layerable: false,
				hoverable: true,
				selectable: true,
				traits: [],
				components: () => {
					if (window.selectedTemplate === 'template3') {
						return `<div class="accolade-title" data-gjs-draggable="true" data-gjs-copyable="false" data-gjs-editable="true"><div class="year" data-gjs-draggable="false" data-gjs-copyable="false" data-gjs-editable="true">Year</div><div class="position" data-gjs-draggable="false" data-gjs-copyable="false" data-gjs-editable="true">Position</div></div><div class="accolade-description" data-gjs-draggable="false" data-gjs-copyable="false" data-gjs-editable="true" ><div class="company-name" data-gjs-draggable="false" data-gjs-copyable="false" data-gjs-editable="true">${_e(
							'title',
						)}</div><div class="description" data-gjs-draggable="false" data-gjs-copyable="false" data-gjs-editable="true">${_e(
							'description',
						)}</div></div>`;
					}
					return `<div data-gjs-draggable="true" data-gjs-copyable="false" data-gjs-highlightable="false" data-gjs-editable="true" class="accolade-wrapper"><div class="accolade-title" data-gjs-draggable="false" data-gjs-copyable="false" data-gjs-editable="true" >Title</div><div class="accolade-line" ></div><div class="accolade-description" data-gjs-draggable="false" data-gjs-copyable="false" data-gjs-editable="true" >${_e(
						'description',
					)}</div></div>`;
				},
			},
		},
		view: {
			// Be default, the tag of the element is the same of the model
			tagName: 'div',

			// Do something with the content once the element is rendered.
			// The DOM element is passed as `el` in the argument object,
			// but you can access it from any function via `this.el`
			onRender(props) {
				const { el } = props;
				const serviceItemToolbar = document.createElement('div');
				serviceItemToolbar.classList.add('accolade-item-toolbar');

				// Drag button
				const btnDrag = generateButtonDrag(props, 'accolades');
				serviceItemToolbar.appendChild(btnDrag);

				// Clone button
				const btnClone = generateButtonClone(props);
				serviceItemToolbar.appendChild(btnClone);

				// Delete button
				const btnDelete = generateButtonDelete(props);
				serviceItemToolbar.appendChild(btnDelete);

				el.append(serviceItemToolbar);
			},
		},
	}); /* API for component type definition */
};
export default AchievementItemComponentFactory;
